<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<h2 class="py-3">{{ $t("Statistic") }}</h2>
			</v-flex>
			<v-flex
				xs12
				md3
				v-for="(statistic, index) in statistics"
				:key="index"
			>
				<Link
					:href="$route(statistic.link, $page.props.tenant.id)"
					:key="index"
				>
					<v-card class="mx-auto">
						<v-list two-line :color="statistic.color" dark>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>
										<h1>
											{{ statistic.value }}
										</h1>
									</v-list-item-title>
									<v-list-item-subtitle class="white--text">
										{{ statistic.title }}
									</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-content>
									<v-icon size="50">
										{{ statistic.icon }}
									</v-icon>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-card>
				</Link>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	props: ["data"],
	components: {
		Link,
	},
	computed: {
		statistics() {
			return [
				{
					icon: "mdi-calendar-month",
					title: this.$t("title.reservations"),
					link: "tenant.reservations.index",
					role: "admin|manager",
					color: "#C09949",
					value: this.data.reservations,
				},
				{
					icon: "mdi-clipboard-list-outline",
					title: this.$t("title.orders"),
					link: "tenant.orders.index",
					role: "admin|manager",
					color: "#c09949",
					value: this.data.orders,
				},
				{
					icon: "mdi-food",
					title: this.$t("title.products"),
					link: "tenant.products.index",
					role: "admin|manager",
					color: "#c09949",
					value: this.data.products,
				},
				{
					icon: "mdi-home-variant-outline",
					title: this.$t("title.outlets"),
					link: "tenant.outlets.index",
					role: "admin|manager",
					color: "#C09949",
					value: this.data.outlets,
				},
				{
					icon: "mdi-table-account",
					title: this.$t("Tables"),
					link: "tenant.tables.index",
					role: "admin|manager",
					color: "#141F35",
					value: this.data.tables,
				},
			];
		},
	},
};
</script>
